import React from 'react';
import { markdownToHtml, sanitizeHtml } from '../../utils/html.utils';

const Markdown = ({ text }) => {
  return (
    <div
      className="markdown-container"
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(markdownToHtml(text)) }}
    />
  );
};

export default Markdown;